namespace GeniuzPOS.QRreport {
    export interface QRywcSpecReportpoDailyForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        SupplId: Serenity.LookupEditor;
    }

    export class QRywcSpecReportpoDailyForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpecReportpoDaily';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecReportpoDailyForm.init)  {
                QRywcSpecReportpoDailyForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRywcSpecReportpoDailyForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'ShopId', w0,
                    'SupplId', w0
                ]);
            }
        }
    }
}
